import { Box, Flex } from '@chakra-ui/react'
import { ContentItem } from 'types/graphql'

import { ItListItemAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

import CardWrapper from '../../CardWrapper/CardWrapper'
import Exclusivity from '../../Exclusivity/Exclusivity'
import Thumbnail from '../../Thumbnail/Thumbnail'
import Title from '../../Title/Title'
import VoiceTip from '../../VoiceTip/VoiceTip'

import useContentCard from './useContentCard'

export type ContentCardProps = {
  profilePictureUrl: string
  brandColor: BrandColor
  url?: string
  title?: string
  voiceTipUrl: string
  hasVoiceTip: boolean
  trackingData: ItListItemAnalyticsProps
  contentItem: ContentItem
  itemId: number
}

const CONTENT_ITEM_HEIGHT = '132px'

const ContentCard = ({
  brandColor,
  profilePictureUrl,
  title,
  voiceTipUrl,
  hasVoiceTip,
  url,
  contentItem,
  trackingData,
  itemId,
}: ContentCardProps) => {
  const { onClick } = useContentCard(brandColor, trackingData, url)
  return (
    <CardWrapper
      itemId={itemId}
      brandColor={brandColor}
      offScreenRender={<Box w="100%" bg="dust" h={CONTENT_ITEM_HEIGHT} />}
    >
      <Flex
        gap={4}
        justifyContent="space-between"
        alignItems="center"
        p={4}
        onClick={onClick}
        cursor="pointer"
      >
        <Flex gap={2} direction="column" alignItems="flex-start">
          <Exclusivity
            brandColor={brandColor}
            isExclusive={contentItem.onlyAvailableOnItList}
          />
          <Title title={title} defaultTitle="Untitled Web Link..." />
          <VoiceTip
            mediaUrl={voiceTipUrl}
            hasVoiceTip={hasVoiceTip}
            title={title}
            pictureUrl={profilePictureUrl}
            brandColor={brandColor}
            trackingData={trackingData}
          />
        </Flex>
        <Thumbnail
          coverUrl={contentItem.coverUrl}
          type="content"
          url={url}
          brandColor={brandColor}
        />
      </Flex>
    </CardWrapper>
  )
}

export default ContentCard
